import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { ContextMenuTrigger } from './nested/trigger'
import { ContextMenuPortal } from './nested/portal'
import { ContextMenuBackdrop } from './nested/backdrop'
import { ContextMenuPositioner } from './nested/positioner'
import { ContextMenuPopup } from './nested/popup'
import { ContextMenuItem } from './nested/item'
import { ContextMenuSeparator } from './nested/separator'
import { ContextMenuGroup } from './nested/group'
import { ContextMenuGroupLabel } from './nested/group-label'
import { ContextMenuCheckboxItem } from './nested/checkbox-item'
import { ContextMenuCheckboxItemIndicator } from './nested/checkbox-item-indicator'
import { ContextMenuRadioGroup } from './nested/radio-group'
import { ContextMenuRadioItem } from './nested/radio-item'
import { ContextMenuRadioItemIndicator } from './nested/radio-item-indicator'
import { ContextMenuSubmenuRoot } from './nested/submenu-root'
import { ContextMenuSubmenuTrigger } from './nested/submenu-trigger'
import { ListItemText } from '../../lib/list-item-text'
import type { PartProps } from '../../lib/part-props'

interface ContextMenuRootProps extends PartProps<BaseContextMenu.Root.Props> {}

function ContextMenu({ children, ...props }: ContextMenuRootProps) {
  return <BaseContextMenu.Root {...props}>{children}</BaseContextMenu.Root>
}

ContextMenu.Trigger = ContextMenuTrigger
ContextMenu.Portal = ContextMenuPortal
ContextMenu.Backdrop = ContextMenuBackdrop
ContextMenu.Positioner = ContextMenuPositioner
ContextMenu.Popup = ContextMenuPopup
ContextMenu.Item = ContextMenuItem
ContextMenu.Separator = ContextMenuSeparator
ContextMenu.Group = ContextMenuGroup
ContextMenu.GroupLabel = ContextMenuGroupLabel
ContextMenu.CheckboxItem = ContextMenuCheckboxItem
ContextMenu.CheckboxItemIndicator = ContextMenuCheckboxItemIndicator
ContextMenu.RadioGroup = ContextMenuRadioGroup
ContextMenu.RadioItem = ContextMenuRadioItem
ContextMenu.RadioItemIndicator = ContextMenuRadioItemIndicator
ContextMenu.SubmenuRoot = ContextMenuSubmenuRoot
ContextMenu.SubmenuTrigger = ContextMenuSubmenuTrigger
ContextMenu.ItemText = ListItemText

export { ContextMenu }
